<template>
  <v-dialog max-width="500" :model-value="isVisible" persistent>
    <v-card :title="`Add enterprise member for (${customer?.company})`">
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-combobox
            name="email"
            label="Email"
            :items="userEmails"
            placeholder="Select an existing user or type an email"
            validate-on="blur"
            v-model="email"
            :rules="[rules.required, rules.email]"
            variant="outlined"
            density="default"
            @update:search="handleUserSearch"
            :loading="loadingUsers"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded="lg" size="large" variant="outlined" color="gray" @click="cancel" :disabled="isLoading">
          Cancel
        </v-btn>
        <v-btn rounded="lg" size="large" color="primary" variant="flat" @click="save" :loading="isLoading">
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validateEmail } from '@/utils/validate'
import { mapState } from 'vuex'
import debounce from '@/utils/debounce'

export default {
  name: 'UnsavedCommentsDialog',
  props: {
    customer: {
      type: Object,
      required: true
    },
    isVisible: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  emits: ['save', 'cancel'],
  data: () => ({
    valid: true,
    email: '',
    userEmails: [],
    rules: {
      required: (value) => !!value || 'Required.',
      email: (value) => {
        return validateEmail(value) || 'Invalid e-mail.'
      }
    }
  }),
  computed: {
    ...mapState({
      loadingAddEnterpriseMember: state => state.enterpriseCustomers.loadingAddEnterpriseMember,
      users: state => state.user.users,
      loadingUsers: state => state.user.loadingUsers
    })
  },
  methods: {
    async save () {
      const { valid } = await this.$refs.form.validate()
      if (valid) {
        this.$emit('save', {
          id: this.customer.payerUser?.id,
          email: this.email,
          enterpriseCustomerId: this.customer.id
        })
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    handleUserSearch: debounce(function (searchVal) {
      const searchTerm = (searchVal || '').trim()
      if (searchTerm.length > 0) {
        this.$store.dispatch('user/listUsers', { search: searchTerm, append: false, fetchAllForSearch: true })
      } else {
        this.fetchInitialUsers()
      }
    }, 500),
    fetchInitialUsers () {
      this.$store.dispatch('user/listUsers', { append: false, fetchAllForSearch: false })
    }
  },
  watch: {
    users (newUsers) {
      this.userEmails = (newUsers || []).map((user) => user.email)
    },
    isVisible (visible) {
      if (visible) {
        this.email = ''
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
        this.fetchInitialUsers()
      }
    }
  }
}
</script>
